export enum ProductTrack {
    NO_TRACK = 0,
    TRACK = 1,
    INHERIT = 99,
}